import React from 'react';
import { Button, type ButtonProps } from '../ui/button.js';
import { cn } from '../../utils.js';

export const MemoraiButton = React.forwardRef<HTMLButtonElement, ButtonProps>(
    ({ children, className, variant, ...props }, ref) => (
        <Button
            ref={ref}
            variant={variant}
            className={cn(
                'transition-all active:scale-[0.98]',
                variant === 'default' && 'bg-primary text-primary-foreground hover:bg-primary/90 shadow-none border-none',
                variant === 'outline' && 'border-border bg-transparent hover:bg-background-subtle text-foreground shadow-none',
                variant === 'ghost' && 'hover:bg-background-subtle text-foreground/70 hover:text-foreground',
                className
            )}
            {...props}
        >
            {children}
        </Button>
    )
);

MemoraiButton.displayName = 'MemoraiButton';
